import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  selectDependentFormIsCareUserCreator,
  selectDependentFormRole,
} from '../../../redux/dependentForm/selectors';
import styles from '../styles.styl';

const mapStateToProps = state => ({
  isCareUserCreator: selectDependentFormIsCareUserCreator(state),
  role: selectDependentFormRole(state),
});

export const enhance = compose(
  connect(mapStateToProps),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentRelation/enhance.js